import React, { useEffect } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Typography
} from '@material-ui/core'
import FlagOutlinedIcon from '@material-ui/icons/FlagOutlined'
import timeAgo from 'utils/timeAgo'
import getNotificationsIds from 'utils/getNotificationsIds'
import { refreshNotifications } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'
import checkToken from 'utils/checkToken'
import appApiUrl from 'utils/apiUrl'
import { useSnackbar } from 'notistack'

const useStyles = makeStyles(theme => ({
  root: {},
  listItem: {
    '&:hover': {
      backgroundColor: theme.palette.background.default
    }
  },
  avatarBlue: {
    color: '#2980B9'
  },
  avatarGreen: {
    color: '#27AE60'
  },
  avatarOrange: {
    color: '#E74C3C'
  },
  avatarRed: {
    color: '#C0392B'
  },
  avatarIndigo: {
    color: '#2980B9'
  },
  arrowForwardIcon: {
    color: theme.palette.icon
  },
  listItemText: { maxWidth: 195, marginBottom: '-0.6em' }
}))

const NotificationList = props => {
  const { enqueueSnackbar } = useSnackbar()
  const { notifications, className, ...rest } = props
  const classes = useStyles()
  const dispatch = useDispatch()
  const userId = useSelector(state => state.session?.userId)
  const token = useSelector(state => state.session?.token)

  const avatars = {
    accept_campaign: <FlagOutlinedIcon className={classes.avatarGreen} />,
    reject_campaign: <FlagOutlinedIcon className={classes.avatarRed} />,
    delete_campaign: <FlagOutlinedIcon className={classes.avatarRed} />,
    disable_campaign: <FlagOutlinedIcon className={classes.avatarRed} />,
    warning_expire_campaign: <FlagOutlinedIcon className={classes.avatarRed} />,
    enable_campaign: <FlagOutlinedIcon className={classes.avatarGreen} />
  }
  useEffect(() => {
    const notificationIds = getNotificationsIds(notifications)
    return () => {
      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/json')
      myHeaders.append('Authorization', `Bearer ${token}`)

      var raw = JSON.stringify({
        userId,
        notificationIds
      })
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      }
      notificationIds &&
        fetch(`${appApiUrl}notifications/setView.php`, requestOptions)
          .then(response => response.json())
          .then(res => {
            checkToken(res, dispatch)
            dispatch(refreshNotifications())
          })
          .catch(error => {
            enqueueSnackbar(error.message, {
              variant: 'error'
            })
          })
    }
  }, [notifications, enqueueSnackbar, token, dispatch, userId])

  return (
    <List {...rest} className={clsx(classes.root, className)} disablePadding>
      {notifications?.map(notification => (
        <ListItem
          className={classes.listItem}
          component={RouterLink}
          key={notification.id}
          to={`/notifications?id=${notification.id}`}>
          <ListItemIcon>
            {avatars[notification.type] || avatars[2]}
          </ListItemIcon>
          <ListItemText
            className={classes.listItemText}
            primary={notification.title}
            primaryTypographyProps={{ variant: 'subtitle2' }}
          />
          <ListItemSecondaryAction>
            <Typography variant="caption">
              {timeAgo(`${notification.date} ${notification.time}`)}
            </Typography>
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  )
}

NotificationList.propTypes = {
  className: PropTypes.string,
  notifications: PropTypes.array.isRequired
}

export default NotificationList
